import React, { useEffect, useState } from "react";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";
import { wire } from "react-hot-wire";

import CircularProgress from "@material-ui/core/CircularProgress";

import { CategoryService } from "../../../../services/prize/category/Category.service";
import { Category } from "../../../../models/prize/category/Category";
import Drawer from "../../../common/drawer/Drawer";

import EditCategory from "./Edit.template";

export type EditCategoryFormValues = {
  name: string;
  supplierCategories: string;
};

const EditCategorySchema = Yup.object().shape({
  name: Yup.string().required(),
  supplierCategories: Yup.string()
});

function EditCategoryComponent({
  categoryService,
  drawerProps,
  action,
  ...props
}: {
  category: Category;
  categoryService: CategoryService;
  drawerProps?: any;
  action?: () => void;
}) {
  const [category, setCategory] = useState<Category | null>(null);
  const [supplierCategories, setSupplierCategories] = useState<any[]>([]);

  useEffect(() => {
    (async () => {
      const category = await categoryService.get(props.category);
      setCategory(category);
    })();
  }, [props.category, categoryService]);

  useEffect(() => {
    if (category && category.parent) {
      (async () => {
        const supplierCategoriesList = await categoryService.getSupplierCategories();
        setSupplierCategories(supplierCategoriesList);
      })();
    }
  }, [category, categoryService]);

  return (
    <Drawer
      {...drawerProps}
      render={({ close }: { close: () => void }) =>
        category ? (
          <Formik
            enableReinitialize
            isInitialValid
            initialValues={{
              name: category.ownName,
              supplierCategories: category.supplierCategories
            }}
            validationSchema={EditCategorySchema}
            onSubmit={(values: EditCategoryFormValues) => {
              const data: any = {
                name: { pl: values.name }
              };

              if (category.parent) {
                data.supplierCategories = values.supplierCategories
                  .split(",")
                  .map((s: string) => s.trim())
                  .filter((s: string) => s);
              }

              return categoryService
                .edit(category, data)
                .then(close)
                .then(action);
            }}
            render={(props: FormikProps<EditCategoryFormValues>) => (
              <EditCategory
                formikProps={props}
                category={category}
                close={close}
                translationPath="prize.category.edit"
                supplierCategories={supplierCategories}
              />
            )}
          />
        ) : (
          <div className="d-flex align-items-center justify-content-center h-100">
            <CircularProgress color="primary" />
          </div>
        )
      }
    />
  );
}

export default wire(["categoryService"], EditCategoryComponent);
